import React from 'react'

import moment from 'moment';

import { withRouter } from 'react-router-dom';

import { Section, Table, Index, InfosBar, SubscriptionDeadline, Empty, TextGroup, Text, Version } from 'components';
import { Container, Button, Icon } from 'semantic-ui-react'

import { ModalCreateDevice } from 'modals';

import { BreadcrumbHelper, Typeof } from 'utils';

const DEVICES_PER_PAGE = 10;

class DeviceListScene extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      devices: props.devices,
      deviceCriteria: '',
      showDeviceCreateModal: false
    };

    this.handleDeviceSearch = this.handleDeviceSearch.bind(this);

    this.toggleDeviceCreateModal = this.toggleDeviceCreateModal.bind(this);
    this.handleDeviceCreateModalClose = this.handleDeviceCreateModalClose.bind(this);

    this.handleDeviceSelect = this.handleDeviceSelect.bind(this);
  }

  componentWillMount() {

    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');
    BreadcrumbHelper.push('Valises');
    BreadcrumbHelper.flush();
  }

  handleDeviceSearch(criteria) {

    this.setState({
      deviceCriteria: criteria
    });
  }

  toggleDeviceCreateModal() {
    this.setState({
      showDeviceCreateModal: !this.state.showDeviceCreateModal
    });
  }

  handleDeviceCreateModalClose(device) {

    if (Typeof.object(device)) {

      let devices = [...this.state.devices];
      devices.push(device);

      this.setState({
        devices: devices
      });
    }

    this.toggleDeviceCreateModal();
  }

  handleDeviceSelect(device) {

    //Navigate to device page
    this.props.history.push(`/devices/${device.id}`);
  }

  render() {

    const { devices } = this.state;

    let columns = [
      {
        id: 'id',
        header: '#',
        value: (device) => device.id,
        render: (device, value) => <Index value={value} />,
        fit: true
      },
      {
        id: 'clinic',
        header: 'Clinique',
        value: (device) => Typeof.object(device.clinic) ? device.clinic : null,
        render: (device, clinic) => {
          return clinic != null ? clinic.name : <Empty />;
        }
      },
      {
        id: 'version',
        header: 'Version',
        value: (device) => [device.app_version, device.ios_version],
        render: (device, versions) => {

          return (
            <TextGroup mode="rows">

              {/* App */}
              <Text style={{"mono" : true}}>
                <Icon name="tablet" />

                {Typeof.string(versions[0]) ? (
                  <Version version={versions[0]} current={this.props.appStoreVersion} />
                ) : (
                  <Empty />
                )}

              </Text>


              {/* iOS */}
              <Text style={{"mono" : true}}>
                <Icon name={"apple"} />

                {Typeof.string(versions[1]) ? (
                  <Text style={{"mono" : true}}>{versions[1]}</Text>
                ) : (
                  <Empty />
                )}

              </Text>

            </TextGroup>
          )
        },
        fit: true
      },
      {
        id: 'update_date',
        header: "Date d'installation",
        value: (device) => Typeof.string(device.update_date) ? moment(device.update_date).format('DD/MM/YYYY HH:mm:ss') : undefined,
        render: (device) => Typeof.string(device.update_date) ? <Text style={{"mono" : true}}>{moment(device.update_date).format('[Le] DD/MM/YYYY [à] HH:mm:ss')}</Text> : <Empty />,
        fit: true
      },
      {
        id: 'subscription_deadline',
        header: "Date limite d'abonnement",
        value: (device) => Typeof.string(device.subscription_deadline) ? moment(device.subscription_deadline).format('DD/MM/YYYY HH:mm:ss') : undefined,
        render: (device) => Typeof.string(device.subscription_deadline) ? <SubscriptionDeadline date={device.subscription_deadline} /> : <Empty />,
        fit: true
      }
    ];

    return (
      <React.Fragment>
        <Container>

          {/* Devices */}
          <Section title="Valises" onSearch={this.handleDeviceSearch} actions={[

            // Add device
            <Button icon="add" content="Nouveau" onClick={this.toggleDeviceCreateModal} key={0} />
          ]}>

            {devices.length > 0 ? (

              <React.Fragment>

                {/* Number of available devices */}
                <InfosBar mode="column">
                  <span>{devices.length > 1 ? `${devices.length} valises disponibles` : '1 valise disponible'}</span>
                </InfosBar>

                {/* devices list */}
                <Table columns={columns}
                  criteria={this.state.deviceCriteria}
                  items={devices}
                  itemsPerPage={DEVICES_PER_PAGE}
                  onSelect={this.handleDeviceSelect}
                  messageEmpty="Aucune valise ne correspond à votre recherche"
                />

              </React.Fragment>

            ) : (

                // No device available
                <InfosBar mode="row">
                  <span>Aucune valise disponible</span>
                </InfosBar>

              )}

          </Section>

        </Container>

        {/* Modal create device */}
        {this.state.showDeviceCreateModal &&
          <ModalCreateDevice onClose={this.handleDeviceCreateModalClose} />
        }

      </React.Fragment>
    );
  }
}

export default withRouter(DeviceListScene);
